import {DropDown,ErrorsWings,TooltipWings, FilterWings, FormRowWings, FilterSelectedItemWings} from "@/components";
import {VueConstructor} from 'vue/types';


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue: VueConstructor) {
    Vue.component("drop-down", DropDown);
    Vue.component("errors-wings", ErrorsWings);
    Vue.component("tooltip-wings", TooltipWings);
    Vue.component("filter-wings", FilterWings);
    Vue.component("form-row-wings", FormRowWings);
    Vue.component("filter-selected-item-wings", FilterSelectedItemWings);
  }
};

export default GlobalComponents;
